import { IGroup } from '@nkr/models/index';
import { IGroupData } from '@nkr/store/index';

interface IValidation {
    name: boolean,
    description: boolean
}

export interface IAddEditState extends IGroupData {
    validation: IValidation
}

export const initialState: IAddEditState = {
    id: 0,
    name: '',
    description: '',
    isSuperAdmin: false,
    canManageUsers: false,
    canUseCp: false,
    canAccessTicketing: false,
    accessTicketGroup: 0,
    canChangeUsername: false,
    canChangePassword: false,
    canEditProfile: false,
    isCenter: false,
    isNkdo: false,
    canAddCenterUser: false,
    isLogisticsProvider: false,
    isXmKitVendor: false,
    isSerologyVendor: false,
    isRecipient: false,
    isDonor: false,
    isPhlebotomist: false,
    isNkrLab: false,
    validation: {
        name: true,
        description: true
    }
}

interface IAction {
    type: string,
    payload?: any
}

export const addEditReducer = (state: IAddEditState, action: IAction): IAddEditState => {
    if (action.type == 'initialize') {
        return {...initialState};
    }

    if (action.type == 'loadData') {
        let { id, name, description, isSuper: isSuperAdmin, manageUsers: canManageUsers, useCP: canUseCp, accessTicketing: canAccessTicketing,
            accessTicketGroup, changeUsername: canChangeUsername, changePassword: canChangePassword, editProfile: canEditProfile,
            isCenter, isNkdo, addCenterUser: canAddCenterUser, isLogisticsProvider,
            isXmKitVendor, isSerologyVendor, isRecipient, isDonor,
            isPhlebot: isPhlebotomist, isNkrLab
        } = action.payload as IGroup;

        return {
            id,
            name,
            description,
            isSuperAdmin,
            canManageUsers,
            canUseCp,
            canAccessTicketing,
            accessTicketGroup, canChangeUsername, canChangePassword, canEditProfile,
            isCenter, isNkdo, canAddCenterUser, isLogisticsProvider,
            isXmKitVendor, isSerologyVendor, isRecipient, isDonor,
            isPhlebotomist, isNkrLab,
            validation: { name: true, description: true }
        };
    }

    if (action.type == 'update') {
        let newState = { ...state, [action.payload.name]: action.payload.value };
        return newState;
    }

    if (action.type == 'validate') {
        let validation: IValidation = {
            name: state.name != '',
            description: state.description != '',
        };

        return { ...state, validation };
    }

    return { ...state };
}
